import { validateGuides } from '@/utils/guides';
import dashboard from './dashboard';
import people from './people';
import events from './events';
import forms from './forms';

export const GUIDES_ENABLED = true;
export const guideCatalog = validateGuides([
    { ...dashboard, enabled: false },
    people,
    { ...events, enabled: false },
    { ...forms, enabled: false },
]);
export const guides = guideCatalog.filter(guide => guide.enabled !== false);
export const getGuide = id => guides.find(guide => guide.id === id);
